import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hashPassword } from '../../utils/hashUtil';
import { EliminarUsuario } from '../../services/userService';
import { login } from '../../services/authService';
import { useUser } from '../../userContext';
import PopupMensaje from '../../iu/popupMensaje/PopupMensaje';
import PopupConfirmarCancelar from '../../iu/popupConfirmarCancerlar/popupConfirmarCancerlar';
import './BorrarDatos.css'; // Reutilizando estilos del login


const BorrarDatos = () => {
    const [popupMensaje, setPopupMensaje] = useState('');
    const [popupKey, setPopupKey] = useState(0);
    const [showConfirm, setShowConfirm] = useState(false);
    const [credentials, setCredentials] = useState({
        correo: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const { iniciarSesion, cerrarSesion, setToken, token, id } = useUser();
    const navigate = useNavigate();

    const handlePopupClose = () => {
        setPopupMensaje('');
        setPopupKey((prevKey) => prevKey + 1);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleVerifyUser = async (e) => {
        e.preventDefault();
        try {
            const hashedPassword = await hashPassword(credentials.password);
            const data = await login(credentials.correo, hashedPassword);
            console.log(data);
            if (!data.accessToken) {
                setPopupMensaje('Acceso denegado');
            } else {
                setToken(data.accessToken);
                const nombreCompleto = `${data.user.nombre} ${data.user.apellido1} ${data.user.apellido2}`;
                iniciarSesion(data.user.id, nombreCompleto, data.user.correo, data.user.telefono, data.user.modulos, data.user.rol);
                setShowConfirm(true);
            }
        } catch (error) {
            setPopupMensaje('Usuario o contraseña incorrectos');
        }
    };

    const handleDeleteAccount = async () => {
        try {
            if (!id) {
                setPopupMensaje('Error: ID de usuario no disponible');
                return;
            }
            console.log(token);
            console.log(id);
            const result = await EliminarUsuario({ token, id });
            console.log(result);
            if (result.id) {
                setPopupMensaje('Tu cuenta ha sido eliminada correctamente');
                cerrarSesion();
                setTimeout(() => {
                    navigate('/inicio');
                }, 5000);
            } else {
                setPopupMensaje(result.message || 'Error al eliminar la cuenta');
            }
        } catch (error) {
            setPopupMensaje('Error al procesar la solicitud');
        } finally {
            setShowConfirm(false);
        }
    };

    const handleInicio = () => {
        navigate('/login');
    };

    return (
        <div className='main'>
            <div className='titulo-componentes mis-reportes'>Eliminar mis datos</div>
            <div className='login-card'>
                <div className='aviso'>⚠️ATENCIÓN: Esta acción eliminará permanentemente todos tus datos y NO podrá deshacerse</div>
                <form onSubmit={handleVerifyUser}>
                    <div className="form-group">
                        <label htmlFor="correo">Correo electrónico</label>
                        <input
                            id="correo"
                            name="correo"
                            className='input-login'
                            type="text"
                            value={credentials.correo}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <input
                            id="password"
                            name="password"
                            className='input-login'
                            type={showPassword ? "text" : "password"}
                            value={credentials.password}
                            onChange={handleInputChange}
                            required
                        />
                        <div className='show-password-container'>
                            <input
                                type="checkbox"
                                id="show-password"
                                checked={showPassword}
                                onChange={toggleShowPassword}
                            />
                            <label htmlFor="show-password">Mostrar contraseña</label>
                        </div>
                    </div>
                    <button className="boton-primario" type="submit">
                        Verificar identidad
                    </button>
                    <div className="register-link">
                        ¿Quieres volver al inicio de sesión? <div onClick={handleInicio}>Inicio</div>
                    </div>
                </form>
                {popupMensaje && (
                    <PopupMensaje
                        key={popupKey}
                        mensaje={popupMensaje}
                        onClose={handlePopupClose}
                    />
                )}

                {showConfirm && (
                    <PopupConfirmarCancelar
                        mensaje="¿Estás seguro que deseas eliminar permanentemente tu cuenta y todos tus datos?"
                        onClose={() => setShowConfirm(false)}
                        onConfirm={handleDeleteAccount}
                    />
                )}
            </div>
        </div>
    );
};

export default BorrarDatos;